var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Icons } from '@beeline/design-tokens/js/iconfont';
import classNames from 'classnames';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import "./styles.css";
export var Radio = React.forwardRef(function (_a, ref) {
    var checked = _a.checked, label = _a.label, disabled = _a.disabled, className = _a.className, name = _a.name, props = __rest(_a, ["checked", "label", "disabled", "className", "name"]);
    return (React.createElement("label", { className: classNames('lk-ui_radio', disabled && 'lk-ui_radio__disabled', className) },
        React.createElement("span", { className: 'lk-ui_radio-root' },
            React.createElement("input", __assign({ type: 'radio', checked: checked, disabled: disabled, name: name, className: 'lk-ui_radio-input' }, props, { ref: ref })),
            React.createElement(Icon, { className: 'lk-ui_radio-icon', size: 'large', iconName: Icons.Dot })),
        label && (React.createElement(React.Fragment, null, typeof label === 'string' ? (React.createElement(Typography, { variant: 'body2', className: 'lk-ui_radio-label' }, label)) : (label)))));
});
